/* eslint-disable */

// import DataTable from '../../../../../components/LynDataTable/DataTable';
import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import ExitButton from 'components/button/ExitButton';
// import comptroller from 'assets/images/comptroller_white.svg';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import ViewEditModalHeader from '../../../../../components/modal/ViewEditModalHeader';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import LeaseDataTable from './LeaseDataTable';

function formatNumber(number, decimals = 2) {
	// First, handle invalid inputs
	if (typeof number !== 'number' || isNaN(number)) {
		throw new Error('Please provide a valid number');
		// return;
	}

	// Round to specified decimal places using toFixed
	// but convert back to number to remove trailing zeros
	const roundedNumber = Number(number.toFixed(decimals));

	// Use Intl.NumberFormat for consistent formatting
	const formatter = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});

	return formatter.format(roundedNumber);
}
const LeaseRecordViewModal = ({ showModal, setShowModal, checkResponseData = [], tableUpperLeftExtraInfo = null }) => {
	// const theme = useTheme();

	const [propcessData, setPropcessData] = useState([]);
	const [showGlData, setShowGlData] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	// const formattedData = (inputData) => {
	// 	// Parse the input if it's a string
	// 	const data = typeof inputData === 'string' ? JSON.parse(inputData) : inputData;

	// 	// Initialize the output array
	// 	const result = [];

	// 	// Process each item in the input data
	// 	for (const item of data) {
	// 		// Check if item has a ccList array with entries
	// 		if (item.ccList && item.ccList.length > 0) {
	// 			// For each cost center in the ccList
	// 			for (const ccItem of item.ccList) {
	// 				// Get cost center code and description
	// 				const costCenterCode = ccItem.ccData ? ccItem.ccData.costCenterCode : ccItem.headCode;
	// 				const costCenterDescription = ccItem.ccData ? ccItem.ccData.costCenterDescription : ccItem.head;

	// 				// Create a new object with the specified properties
	// 				result.push({
	// 					costCenter: costCenterCode,
	// 					costCenterDescription: costCenterDescription,
	// 					debit: ccItem.debit,
	// 					credit: ccItem.credit,
	// 					glAccount: item.glData.generalLedgerCode,
	// 					glAccountDescription: item.glData.generalLegerDescription,
	// 					description: item.description,
	// 				});
	// 			}
	// 		}
	// 	}

	// 	return result;
	// };
	useEffect(() => {
		setIsLoading(true);
		let arrayExcludeData = [];

		// First, filter out items with group 'Payment'
		const filteredData = checkResponseData?.filter((item) => item?.group !== 'Payment');

		// Process items with cost centers
		filteredData.forEach((item) => {
			if (Boolean(item?.glData)) {
				setShowGlData(true);
			}

			// If item has ccList, create an entry for each cost center
			if (item?.ccList && item?.ccList.length > 0) {
				item.ccList.forEach((ccItem) => {
					// Get cost center code and description - use empty string if not available
					const costCenterCode = ccItem.headCode ? ccItem.headCode : '';
					const costCenterDescription = ccItem.head ? ccItem.head : '';
					const coListCredit = ccItem.credit;
					const coListDebit = ccItem.debit;

					let itemData = {
						date: item?.entryDate?.dateString ? dayjs(item?.entryDate?.dateString).format('YYYY-MM-DD') : '',
						head: item?.head ? item?.head : '',
						description: item?.description ? item?.description : '',
						debit: coListDebit,
						credit: coListCredit,
						costCenterCode: costCenterCode,
						costCenterDescription: costCenterDescription,
						headCode: item?.headCode ? item?.headCode : '',
						glAccount: item?.glData?.generalLedgerCode || '',
						glAccountDescription: item?.glData?.generalLegerDescription || '',
						headGroup: item?.headGroup ? item?.headGroup : '',
					};

					try {
						if (!isNaN(ccItem?.debit) && ccItem?.debit !== null && ccItem?.debit !== undefined) {
							itemData.debit = formatNumber(ccItem?.debit);
						}
					} catch (error) {
						// Keep default value of 0
					}

					try {
						if (!isNaN(ccItem?.credit) && ccItem?.credit !== null && ccItem?.credit !== undefined) {
							itemData.credit = formatNumber(ccItem?.credit);
						}
					} catch (error) {
						// Keep default value of 0
					}

					arrayExcludeData.push(itemData);
				});
			} else {
				let itemData = {
					date: item?.entryDate?.dateString ? dayjs(item?.entryDate?.dateString).format('YYYY-MM-DD') : '',
					head: item?.head ? item?.head : '',
					description: item?.description ? item?.description : '',
					debit: item?.debit ? item?.debit : 0,
					credit: item?.credit ? item?.credit : 0,
					costCenterCode: '',
					costCenterDescription: '',
					headCode: item?.headCode ? item?.headCode : '',
					glAccount: item?.glData?.generalLedgerCode || '',
					glAccountDescription: item?.glData?.generalLegerDescription || '',
					headGroup: item?.headGroup ? item?.headGroup : '',
				};

				try {
					if (!isNaN(item?.debit) && item?.debit !== null && item?.debit !== undefined) {
						itemData.debit = formatNumber(item?.debit);
					}
				} catch (error) {
					// Keep default value of 0
				}

				try {
					if (!isNaN(item?.credit) && item?.credit !== null && item?.credit !== undefined) {
						itemData.credit = formatNumber(item?.credit);
					}
				} catch (error) {
					// Keep default value of 0
				}

				arrayExcludeData.push(itemData);
			}
		});

		setPropcessData(arrayExcludeData);
		setIsLoading(false);
	}, [checkResponseData]);

	const checkColumnDesign = useMemo(
		() => [
			{
				id: 'date',
				width: '5%',
				align: 'center',
				accessor: 'date',
				cellAlign: 'center',
				Header: 'Date',

				Cell: (cell) => {
					const formattedDate = cell?.row?.original?.date ? dayjs(cell.row.original.date).format('YYYY-MM-DD') : '';
					return (
						<div>
							<Typography align="center">{formattedDate}</Typography>
						</div>
					);
				},
			},
			{
				id: 'ccHeadCode',
				width: '5%',
				align: 'center',
				accessor: 'ccHeadCode',
				cellAlign: 'left',
				Header: 'Cost Center',
				isVisible: showGlData,
				Cell: (cell) => {
					return (
						<div style={{ textAlign: 'left' }}>
							<Typography>{cell?.row?.original?.costCenterCode}</Typography>
						</div>
					);
				},
			},
			{
				id: 'ccDescription',
				width: '5%',
				align: 'center',
				accessor: 'ccDescription',
				cellAlign: 'left',
				Header: 'Cost Center Description',
				isVisible: showGlData,
				Cell: (cell) => {
					return (
						<div style={{ textAlign: 'left' }}>
							<Typography>{cell?.row?.original?.costCenterDescription}</Typography>
						</div>
					);
				},
			},
			{
				id: 'glAccount',
				width: '5%',
				align: 'center',
				accessor: 'glAccount',
				cellAlign: 'left',
				Header: 'GL Account',
				isVisible: showGlData,
				Cell: (cell) => {
					return (
						<div style={{ textAlign: 'left' }}>
							<Typography>{cell?.row?.original?.glAccount}</Typography>
						</div>
					);
				},
			},
			{
				id: 'glDescription',
				width: '5%',
				align: 'center',
				accessor: 'glDescription',
				cellAlign: 'left',
				Header: 'GL Account Description',
				isVisible: showGlData,
				Cell: (cell) => {
					return (
						<div style={{ textAlign: 'left' }}>
							<Typography>{cell?.row?.original?.glAccountDescription}</Typography>
						</div>
					);
				},
			},
			{
				id: 'leaserHead',
				width: '5%',
				align: 'center',
				accessor: 'headGroup',
				cellAlign: 'left',
				Header: 'Lease Heads',
				isVisible: !showGlData,
				Cell: (cell) => {
					// console.log('🚀 ~ LeaseRecordViewModal ~ cell:', cell?.row?.original?.headGroup);
					return (
						<div style={{ textAlign: 'left' }}>
							<Typography>{cell?.row?.original?.headGroup}</Typography>
						</div>
					);
				},
			},
			{
				id: 'description',
				width: '5%',
				align: 'center',
				accessor: 'description',
				cellAlign: 'left',
				Header: 'Description',
				Cell: (cell) => {
					return (
						<div style={{ textAlign: 'left' }}>
							<Typography>{cell?.row?.original?.description}</Typography>
						</div>
					);
				},
			},

			{
				id: 'debit',
				width: '5%',
				align: 'center',
				accessor: 'debit',
				cellAlign: 'center',
				Header: 'Debit',
				Cell: (cell) => {
					return (
						<div>
							<Typography align="right">{cell?.row?.original?.debit ? cell?.row?.original?.debit : ''}</Typography>
						</div>
					);
				},
			},
			{
				id: 'credit',
				width: '5%',
				align: 'center',
				accessor: 'credit',
				cellAlign: 'center',
				Header: 'Credit',
				Cell: (cell) => {
					return (
						<div>
							<Typography align="right">{cell?.row?.original?.credit ? cell?.row?.original?.credit : ''}</Typography>
						</div>
					);
				},
			},
		],
		[]
	);
	const defaultVisibleColumn = useMemo(() => {
		// Return an array of column IDs that should be hidden (where isVisible is false)
		return checkColumnDesign.filter((column) => column.isVisible === false).map((column) => column.id);
	}, [checkColumnDesign]);
	const handleClose = () => {
		setShowModal(false);
	};

	const renderContent = () => {
		if (isLoading) {
			return (
				<Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
					<Spin size="large" />
				</Box>
			);
		}

		if (!propcessData || propcessData.length === 0) {
			return (
				<Box display="flex" justifyContent="center" alignItems="center" minHeight="200px" flexDirection="column">
					<Typography variant="h6" color="textSecondary" gutterBottom>
						No Data Available
					</Typography>
					<Typography variant="body2" color="textSecondary">
						There are no journal entries to display.
					</Typography>
				</Box>
			);
		}

		return (
			<LeaseDataTable
				xlsxFileName={`${tableUpperLeftExtraInfo?.retirementId}_date`}
				firstColStrick={false}
				COLUMNS={checkColumnDesign || []}
				DATA={propcessData || []}
				pageSize={propcessData?.length}
				pagination={false}
				onClickHandler={() => {}}
				columnFilterSelector={true}
				tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
				defaultVisibleColumn={defaultVisibleColumn}
			/>
		);
	};

	return (
		<React.Fragment>
			<Dialog
				fullWidth={true}
				maxWidth={'lg'}
				open={showModal}
				keepMounted
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{ '& .MuiPaper-root': { borderRadius: '8px' } }}
			>
				<ViewEditModalHeader
					headerTitle="Journal Entry"
					// type={type}
					handleClose={handleClose}
					// icon={comptroller}
					// screenSize={screenSize}
					isScreenSize={false}
					// setScreenSize={setScreenSize}
					icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
				/>

				<DialogContent sx={{ pb: { xs: 4, md: 7 } }}>{renderContent()}</DialogContent>
			</Dialog>
		</React.Fragment>
	);
};
export default LeaseRecordViewModal;
